<template>
  <div class="download-showcase card">
    <div class="download-showcase-visual">
      <img
        :src="data.image"
        :alt="data.imageAlt"
        width="512"
        height="512"
        loading="eager"
        fetchpriority="high"
        class="download-showcase-img"
      />
    </div>
    <div class="download-showcase-info">
      <h2 class="download-showcase-title">{{ data.title }}</h2>
      <ul class="download-showcase-bullets">
        <li v-for="(line, i) in data.bullets" :key="i">{{ line }}</li>
      </ul>
      <router-link :to="data.ctaTo" class="btn-primary btn-large download-showcase-cta">
        ⬇ {{ data.ctaText }}
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DownloadShowcase',
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>
